import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {AcDialog, DIALOG_CONFIG} from 'ac-infra';

@AcDialog({
  title: 'Chart Details',
  cancelButtonText: 'Ok',
  width: 700,
})
@Component({
  selector: 'chart-dialog',
  templateUrl: './chart-dialog.component.html',
  styleUrls: ['./chart-dialog.component.less']
})
export class ChartDialogComponent implements OnInit {
  chartOptions: any;

  constructor(@Inject(DIALOG_CONFIG) public dialogConfig) {
    this.chartOptions = {...dialogConfig.dialogData, exporting: true};
  }

  ngOnInit(): void {
  }
}
